export const AUTHENTICATE_TYPE = {
  LOGIN: 'login',
  SIGN_UP: 'signup',
};
